/** Strings for the agent and person profiles and the user model (S9, K3). */
export const profilesCopy = {
  retry: 'Retry',
  agentTitle: 'Agent',
  workspaceCrumb: 'Workspace',
  loadAgentFailed: 'Could not load this agent.',
  loadMembersFailed: 'Could not load workspace members.',
  refreshAgentFailed: 'Could not refresh this agent.',
  refreshMembersFailed: 'Could not refresh workspace members.',
  refreshMemoryFailed: 'Could not refresh memory entries.',
  refreshUserModelFailed: 'Could not refresh the user model.',
  deleteEntry: (key: string) => `Delete ${key}`,
  callingTool: (tool: string) => `calling ${tool}`,
  newObservation: 'Add observation',
  agent: {
    meta: (model: string, added: string) =>
      `workspace agent · ${model} · added ${added}`,
    reconcilePending: (name: string) => `${name} updated`,
    deleted: 'Agent deleted',
    reconcileFailed: 'Failed to reconcile agent — try again.',
    updateFailed: 'Failed to update agent — try again.',
    runningCount: (count: number) => `${count} running`,
    paused: 'paused',
    deletedBadge: 'deleted',
    reconciling: 'reconciling',
    retryNow: 'Retry now',
    restore: 'Restore',
    pause: 'Pause',
    edit: 'Edit',
    delete: 'Delete',
    runningNow: 'Running now',
    nothingRunning: 'Nothing running.',
    runningDot: 'running',
    topicFallback: 'topic',
    runs: 'Runs',
    deleteTitle: 'Delete agent',
    deleteDescription:
      'Removes the agent from its topics. It can be restored later.',
    deleteConfirm: 'Delete',
  },
  memory: {
    title: 'Memory',
    empty: 'No memory entries yet.',
    saved: 'Memory entry saved',
    saveFailed: 'Failed to save memory entry — try again.',
    deleted: 'Memory entry deleted',
    deleteFailed: 'Failed to delete memory entry — try again.',
    loadFailed: 'Could not load memory entries.',
    delete: 'Delete',
    keyLabel: 'Key',
    keyHelp: 'Reusing an existing key overwrites that entry.',
    keyPlaceholder: 'project_goals',
    textLabel: 'Text',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add entry',
    deleteTitle: 'Delete memory entry',
    deleteDescription: (key: string) => `Permanently deletes "${key}".`,
    deleteConfirm: 'Delete',
  },
  person: {
    defaultRole: 'member',
    meta: (role: string) => `workspace member · ${role}`,
    metaJoined: (role: string, joined: string) =>
      `workspace member · ${role} · joined ${joined}`,
    youChip: 'You',
    userModelTitle: 'User model',
    userModelIntro: 'Recorded preferences and profile context',
  },
  userModel: {
    added: 'Observation added',
    addFailed: 'Failed to add observation — try again.',
    deleted: 'Observation deleted',
    deleteFailed: 'Failed to delete observation — try again.',
    loadFailed: 'Could not load the user model.',
    empty: 'Nothing recorded yet.',
    byAgent: (name: string) => `by ${name} · `,
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add observation',
    deleteTitle: 'Delete observation',
    deleteDescription: 'Agents will no longer see this observation.',
    deleteConfirm: 'Delete',
  },
} as const
